import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://guatemalanspirit.it";
const NOINDEX = [/^\/admin/, /^\/agente/, /^\/mobile/, /^\/account/, /^\/accedi/, /^\/registrati/, /^\/password/, /^\/reset-password/, /^\/pagamento/, /^\/app/];

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    selector.replace(/\[(\w+(?::\w+)?)="([^"]+)"\]/g, (_, k, v) => { el.setAttribute(k, v); return ""; });
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export default function SeoHead() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    document.head.querySelectorAll('script[data-seo="prerender"]').forEach((el) => el.remove());
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const keepQuery = path === "/negozio" && search === "?cat=collezione" ? search : "";
    const url = SITE + path + keepQuery;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    const noindex = NOINDEX.some((re) => re.test(path));
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
  }, [pathname, search]);
  return null;
}
